import { GatewayMethodFormValue } from 'pages/Gateways/GatewaysEdit/types';
import { useChoicesContext } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { AutocompleteMultiselectInput } from 'shared/react-admin/Inputs';
import { Method } from 'types/embedded/method';

type Props = {
  onAddGatewayMethod: (methodId: string, methodName: string) => void;
  onRemoveGatewayMethod: (index: number) => void;
};

export const GatewaysEditMethodsAutocomplete = ({
  onAddGatewayMethod,
  onRemoveGatewayMethod,
}: Props): JSX.Element => {
  const { allChoices, selectedChoices } = useChoicesContext<Method>();
  const gatewayMethods: GatewayMethodFormValue[] = useWatch({ name: 'gatewayMethods' }) || [];

  const handleChange = (methodIds: string[]) => {
    const addedMethodId = methodIds.find(
      (methodId) => !gatewayMethods.some((gatewayMethod) => gatewayMethod.method === methodId),
    );
    if (addedMethodId) {
      const addedMethod = [...(allChoices || []), ...(selectedChoices || [])].find(
        (method) => method['@id'] === addedMethodId,
      );
      onAddGatewayMethod(addedMethodId, addedMethod?.name || '');
      return;
    }

    const removedIndex = gatewayMethods.findIndex(
      (gatewayMethod) => !methodIds.includes(gatewayMethod.method || ''),
    );
    if (removedIndex !== -1) {
      onRemoveGatewayMethod(removedIndex);
    }
  };

  return (
    <AutocompleteMultiselectInput
      clearIcon={false}
      label="Методы"
      name="method"
      onChange={handleChange}
      optionText="name"
      optionValue="@id"
    />
  );
};
